import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface PhoneInputNumberInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const NumberInputComponent: React.FC<PhoneInputNumberInputProps> = props => {
  return <input autoComplete="off" {...props} />;
};

export const NumberInput: React.FC<PhoneInputNumberInputProps> = (
  props: PhoneInputNumberInputProps
) => {
  const Component = useCustomComponent({
    componentName: 'PhoneInputNumberInput',
    Component: NumberInputComponent,
  });

  return <Component {...props} />;
};
